import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
// services
import { AdminDatetimeAmendService } from '../../services/admin-datetime-amend.service';
import { ErrorHandler } from '../../services/error-handler.service';
// models
import { AdminDateTime } from '../../models/admin-datetime.interface';
// store
import { Subscription } from 'rxjs';

import moment from 'moment';

@Component({
  selector: 'app-booking-details-timeslots',
  templateUrl: './booking-details-timeslots.component.html',
  styleUrls: ['./booking-details-timeslots.component.scss'],
  providers: [AdminDatetimeAmendService]
})
export class BookingDetailsTimeslotsComponent implements OnInit, OnDestroy {

  @Input()
  appCopy;
    
  @Input()
  selectedLanguage;

  @Input()
  bookingRef;

  @Input()
  user;

  @Input()
  viewState;

  @Input()
  bookingDetails;

  @Output()
  redirectToBooking: EventEmitter<any> = new EventEmitter();

  private datetimeUpdatedSubscription: Subscription;

  public timeslot = {
    original: {
      acceptance: '',
      repatriation: '',
      hours: null,
      minutes: null
    },
    updated: {
      date: null,
      hours: null,
      minutes: null,
      acceptance: null,
      repatriation: null
    }
  };
  public flightDirection;
  public showAcceptanceEdit = false;
  public showRepatriationEdit = false;
  public isEditable = false;
  public isLoading = false;
  public minDate = null;
  public maxDate = null;
  public disableDates = [];

  constructor(
    private _adminDatetimeAmendService: AdminDatetimeAmendService,
    private _errorHandler: ErrorHandler
  ) { }

  ngOnInit() {

    this.flightDirection = this.bookingDetails.flightStatus.flightDirection;

    if (this.flightDirection === 1) {
      this.timeslot.original.repatriation = this.bookingDetails.deliveryDateTimeUTC;
      this.timeslot.updated.repatriation = moment(this.timeslot.original.repatriation);
      this.minDate = moment(this.timeslot.original.repatriation).subtract(1, 'year');
      this.maxDate = moment(this.timeslot.original.repatriation).add(1, 'year');
      this.timeslot.updated.hours = this.checkIfSingleNumber(moment(this.timeslot.original.repatriation).hours());
      this.timeslot.updated.minutes = this.checkIfSingleNumber(moment(this.timeslot.original.repatriation).minutes());

    } else {
      this.timeslot.original.acceptance = this.bookingDetails.collectionDateTimeUTC;
      this.timeslot.updated.acceptance = moment(this.timeslot.original.acceptance);
      this.minDate = moment(this.timeslot.original.acceptance).subtract(1, 'year');
      this.maxDate = moment(this.timeslot.original.acceptance).add(1, 'year');
      this.timeslot.updated.hours = this.checkIfSingleNumber(moment(this.timeslot.original.acceptance).hours());
      this.timeslot.updated.minutes = this.checkIfSingleNumber(moment(this.timeslot.original.acceptance).minutes());
    }

    this.datetimeUpdatedSubscription = this._adminDatetimeAmendService.datetimeUpdated$
      .subscribe((res: boolean) => {
        if (res) {
          this._errorHandler.handleCustomInfo({
            text: 'The date and time has been updated',
            type: 'success'
          });
          this.isLoading = false;
          this.redirectToBooking.emit(true);
        }
      },
      err => this.isLoading = false);

  }

  dateChanged(val) {
    this.timeslot.updated.date = val;
  }

  checkIfSingleNumber(v) {
    let result = null;
    const str = v.toString();

    if (str.length === 1) {
      result = '0' + str;
    } else {
      result = str;
    }

    return result;

  }

  handleTimeslotSubmit(value, event: Event) {
    event.preventDefault();

    this.isLoading = true;

    const request: AdminDateTime = {
      bookingJourneyReference: this.bookingDetails.bookingJourneyReference,
      bookingReference: this.bookingRef,
      updatedDateTime: ''
    };

    if (this.flightDirection === 1) {

      // if date isn't selected set to original
      if (this.timeslot.updated.date === null) { this.timeslot.updated.date = this.timeslot.original.repatriation; }

      const selectedMoment = moment(this.timeslot.updated.date).hours(parseInt(value.repatriationHours, 10)).minutes(parseInt(value.repatriationMinutes, 10));
      request.updatedDateTime = selectedMoment.format('YYYY-MM-DDTHH:mm:ss');
      this._adminDatetimeAmendService.amendDeliveryDateTime(request, this.user.userToken);
    } else {

      // if date isn't selected set to original
      if (this.timeslot.updated.date === null) { this.timeslot.updated.date = this.timeslot.original.acceptance; }

      const selectedMoment = moment(this.timeslot.updated.date).hours(parseInt(value.acceptanceHours, 10)).minutes(parseInt(value.acceptanceMinutes, 10));
      request.updatedDateTime = selectedMoment.format('YYYY-MM-DDTHH:mm:ss');
      this._adminDatetimeAmendService.amendCollectionDateTime(request, this.user.userToken);
    }

  }

  ngOnDestroy() {
    this.datetimeUpdatedSubscription.unsubscribe();
  }

}
